module.exports = __webpack_public_path__ + "resources/img/img_t3q_search.698fefaaa116e6ba8dda301224ee83d2.png";